import { FormControl } from 'baseui/form-control'
import PropTypes from 'prop-types'
import { Spinner } from 'baseui/spinner'
import SDInput from '@/shared/components/SDComponentsNewDesign/SDInput/SDInput'
import { useTranslation } from 'react-i18next'
import ForceEmail from '@/containers/SubscriptionFormPageNew/Components/Contact/Fields/Default/Email/ForceEmail'

const Email = ({
  caption,
  captionForceEmail,
  currentValue,
  error,
  isLoading,
  mandatory,
  removeErrors,
  updateNeverBounce,
  verifyEmail,
  disabled,
  neverBounceResult,
}) => {
  const { t } = useTranslation()
  let status = ''
  if (neverBounceResult === false) {
    status = 'error'
  } else if (neverBounceResult === 'valid' || neverBounceResult === 'force') {
    status = 'valid'
  }
  const enhancer = () => {
    if (isLoading) {
      return <Spinner size='18px' />
    }
    return null
  }
  const forceAddress = () => {
    captionForceEmail(true)
    updateNeverBounce('force')
    removeErrors('email')
  }

  return (
    <>
      <FormControl error={error} caption={caption}>
        <SDInput
          label={t('subscriptionForm:customer_module.email.label') + mandatory}
          id='customer-input-email'
          disabled={disabled}
          currentValue={currentValue}
          error={error}
          endEnhancer={enhancer}
          onBlur={verifyEmail}
          status={status}
        />
      </FormControl>
      <ForceEmail
        hidden={!error}
        forceAddress={forceAddress}
        label={t('subscriptionForm:customer_module.email.forceLabel')}
        buttonText={t('subscriptionForm:customer_module.email.forceButton')}
      />
    </>
  )
}

Email.propTypes = {
  caption: PropTypes.string,
  captionForceEmail: PropTypes.func,
  currentValue: PropTypes.string,
  error: PropTypes.string,
  isLoading: PropTypes.bool,
  mandatory: PropTypes.string,
  onChangeHandler: PropTypes.func,
  removeErrors: PropTypes.func,
  updateNeverBounce: PropTypes.func,
  verifyEmail: PropTypes.func,
  disabled: PropTypes.bool,
  neverBounceResult: PropTypes.string,
}

export default Email
